var map = {
	"./1.png": "b154",
	"./2.png": "0b67e",
	"./3.png": "6926",
	"./benqi.png": "aed5",
	"./huangguan.png": "6700",
	"./jiangbei.png": "7f05",
	"./jiaobiao.png": "f85a",
	"./maisui1.png": "1dce",
	"./maisui2.png": "f1aa",
	"./tuandui.png": "0779"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1fa";